import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import '../styles/header.css'; // Importar archivo de estilo CSS

const Header = () => {
  return (
<Navbar className="navbar-salmon fixed-top" expand="lg">
  <Container className="d-flex align-items-center justify-content-between">
    {/* Logo + Brand */}
    <div className="d-flex align-items-center">
      <img src="assets/dist/img/logo.png" alt="Logo" className="logo-header" />
      <Navbar.Brand className="ms-2">Morena Mía Café</Navbar.Brand>
    </div>

    {/* Botón hamburguesa y nav */}
    <Navbar.Toggle aria-controls="navbarNav" />
    <Navbar.Collapse id="navbarNav">
      <Nav className="ms-auto">
        <Nav.Link href="#inicio">Inicio</Nav.Link>
        <Nav.Link href="#menu">Tienda</Nav.Link>
        <Nav.Link href="#servicios">Servicios</Nav.Link>
        <Nav.Link href="#contacto">Contacto</Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Container>
</Navbar>



  );
};

export default Header;
